import { FORTA_WHITE } from '../../utils/colors';

import type { IconProps } from './types';

const ChangeStageIcon = (props: IconProps) => {
  const { color = FORTA_WHITE } = props;

  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.33325 9.16683L4.80292 8.6365L4.27259 9.16683L4.80292 9.69716L5.33325 9.16683ZM17.9166 10.8335C17.9166 11.2477 18.2524 11.5835 18.6666 11.5835C19.0808 11.5835 19.4166 11.2477 19.4166 10.8335H17.9166ZM8.13626 5.30317L4.80292 8.6365L5.86358 9.69716L9.19692 6.36383L8.13626 5.30317ZM4.80292 9.69716L8.13626 13.0305L9.19692 11.9698L5.86358 8.6365L4.80292 9.69716ZM5.33325 9.91683H16.9999V8.41683H5.33325V9.91683ZM16.9999 9.91683C17.5062 9.91683 17.9166 10.3272 17.9166 10.8335H19.4166C19.4166 9.49881 18.3346 8.41683 16.9999 8.41683V9.91683Z"
        fill={color}
      />
      <path
        d="M18.6667 15.8333L19.1971 15.303L19.7274 15.8333L19.1971 16.3637L18.6667 15.8333ZM6.16675 15.8333L6.16675 16.5833L6.16675 16.5833L6.16675 15.8333ZM3.75008 14.1667C3.75008 13.7525 4.08587 13.4167 4.50008 13.4167C4.91429 13.4167 5.25008 13.7525 5.25008 14.1667L3.75008 14.1667ZM15.8637 11.9697L19.1971 15.303L18.1364 16.3637L14.8031 13.0303L15.8637 11.9697ZM19.1971 16.3637L15.8637 19.697L14.8031 18.6363L18.1364 15.303L19.1971 16.3637ZM18.6667 16.5833L6.16675 16.5833L6.16675 15.0833L18.6667 15.0833L18.6667 16.5833ZM6.16675 16.5833C4.83206 16.5833 3.75008 15.5014 3.75008 14.1667L5.25008 14.1667C5.25008 14.6729 5.66049 15.0833 6.16675 15.0833L6.16675 16.5833Z"
        fill={color}
      />
      <circle cx="12" cy="12.5" r="11.25" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};

export default ChangeStageIcon;
